import type {VectorCustomization} from '@yandex/ymaps3-types'
import {useTransition} from '@yandex-delivery/blocks'

import {MAP_CUSTOMIZATION_KEY} from '../model'

const customizationStyleLoader = (theme: 'light' | 'dark'): Promise<VectorCustomization> => {
  return import(/* webpackChunkName: 'map-style' */ `../assets/style-${theme}.json`).then(r => r.default)
}

export const useCustomization = (theme: 'light' | 'dark') => {
  const [{payload: customization}] = useTransition(() => customizationStyleLoader(theme), {key: MAP_CUSTOMIZATION_KEY})
  return customization
}
